interface ExtSubjects {
  [level: string]: string[];
}

/**
 * Previously the content was fetched from the backend. For
 * performance reason we wanted to optimize this http call so
 * we didn't have to query the database. Therefore we put the
 * content in a .json file. This is OK since this content rarely
 * changes. However since the content is already hard-coded and
 * the list of subjects in to that long, we can make it part of
 * js bundle.
 */
export const EXT_SUBJECTS: ExtSubjects = {
  'ALL': [
    'aardrijkskunde',
    'bedrijfseconomie',
    'biologie',
    'duits',
    'economie',
    'engels',
    'frans',
    'geschiedenis',
    'latijn',
    'natuur- en scheikunde 1',
    'natuur- en scheikunde 2',
    'natuurkunde',
    'nederlands',
    'scheikunde',
    'spaans',
    'wiskunde',
    'wiskunde a',
    'wiskunde b',
    'wiskunde c',
  ],
  'HAVO': [
    'aardrijkskunde',
    'bedrijfseconomie',
    'biologie',
    'duits',
    'economie',
    'engels',
    'frans',
    'geschiedenis',
    'natuurkunde',
    'nederlands',
    'scheikunde',
    'spaans',
    'wiskunde a',
    'wiskunde b',
  ],
  'VMBO TL': [
    'aardrijkskunde',
    'biologie',
    'duits',
    'economie',
    'engels',
    'frans',
    'geschiedenis',
    'natuur- en scheikunde 1',
    'natuur- en scheikunde 2',
    'nederlands',
    'wiskunde',
  ],
  'VWO': [
    'aardrijkskunde',
    'bedrijfseconomie',
    'biologie',
    'duits',
    'economie',
    'engels',
    'frans',
    'geschiedenis',
    'natuurkunde',
    'nederlands',
    'scheikunde',
    'spaans',
    'wiskunde a',
    'wiskunde b',
    'wiskunde c',
  ],
};
